<template>
  <div id="updateProcess" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/BrandMerchandise' }">品牌商品库</el-breadcrumb-item>
      <el-breadcrumb-item>更新进程</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page" style="margin-bottom: 10px;" v-if="settingfixed.weeks">
      <el-row>
        <el-col :span="12" style="margin-bottom: 10px;font-size: 16px;font-weight: 600;height: 32px;line-height: 32px;">
          固定周期更新计划
        </el-col>
        <el-col :span="12" style="margin-bottom: 10px;text-align: right;">
          <el-button plain size="small" @click="deleteShow = true" v-if="settingfixed.weeks || settingfixed.regulartime">删除任务</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          更新时间：
          <span v-if="settingfixed.weeks || settingfixed.regulartime">{{settingfixed.weeks}} {{settingfixed.regulartime}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8">
          数据范围：
          <span v-if="settingfixed.productname">{{settingfixed.productname}}</span>
          <span v-if="settingfixed.shopnames">{{settingfixed.shopnames}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8">
          设置时间：
          <span v-if="settingfixed.createtime">{{settingfixed.createtime | fullTime}}</span>
          <span v-else>--</span>
        </el-col>
      </el-row>
    </div>
    <section class="seaerch-wrapper">
      <el-row>
        <el-col :span="8" style="margin-bottom: 10px;">
          平台：
          <span v-if="platform">{{platform | platformChinese}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8" style="margin-bottom: 10px;">
          更新方式：
          <span v-if="regulartime">
            定时更新 {{regulartime | fullTime}}
          </span>
          <span v-else-if="timeweek">
            固定周期更新 {{week}} {{timeweek}}
          </span>
          <span v-else>
            即刻更新
          </span>
        </el-col>
        <el-col :span="8" style="margin-bottom: 10px;">
          更新内容：
          <span v-if="settingtype == 0">
            全部未打标
          </span>
          <el-popover v-if="settingtype == 1">
            <div v-for="items in productnameArr">
              {{items}}
            </div>
            <span class="spanPointer" slot="reference">
              按售价分类更新
            </span>
          </el-popover>
          <el-popover v-if="settingtype == 2">
            <div v-for="item in productnameArr">
              {{item}}
            </div>
            <span class="spanPointer" slot="reference">
              按产品信息更新
            </span>
          </el-popover>
          <el-popover v-if="settingtype == 3">
            <div>
              数据更新时间：{{newBegintime | fullTime}} ~ {{newEndtime | fullTime}}
            </div>
            <span class="spanPointer" slot="reference">
              按更新时间更新
            </span>
          </el-popover>
          <span v-if="settingtype == 4">
            全部已打标
          </span>
          <el-popover v-if="settingtype == 5">
            <div v-for="item in shopnameArr">
              {{item}}
            </div>
            <span class="spanPointer" slot="reference">
              按店铺更新
            </span>
          </el-popover>
          <span v-if="settingtype == 6">
            按当日失败更新
          </span>
          <span v-if="settingtype == 7">
            按{{ $store.state.globalLowPrice }}更新
          </span>
          <span v-if="settingtype == 8">
            按销量更新
          </span>

        </el-col>
        <el-col :span="8" style="margin-bottom: 10px;">
          创建时间：
          <span v-if="createtime">{{createtime | fullTime}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8" style="margin-bottom: 10px;">
          开始时间：
          <span v-if="starttime">{{starttime | fullTime}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8" style="margin-bottom: 20px;">
          完成时间：
          <span v-if="updatetime != '' && settingUpdateProgress == 3">{{updatetime | fullTime}}</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="8" style="margin-bottom: 10px;">
          总耗时：
          <span v-if="minute != 0 && updatetime != '' && settingUpdateProgress == 3" >{{Math.ceil(minute)}}分钟</span>
          <span v-else>--</span>
        </el-col>
        <el-col :span="16" style="margin-bottom: 20px;" v-if="settingUpdateProgress || settingUpdateProgress == 0">
          <!-- 定时更新等待  即刻更新排队 -->
          <el-button plain style="margin-right: 10px;float: right;" size="small" @click="cancelUpdate" v-if="settingUpdateProgress == 0 || settingUpdateProgress == 4">取消本次更新</el-button>
        </el-col>
        <div style="width: 100%;height: 50px;float: right;margin-bottom: 10px;">
          <div style="float: left;width: 20%;text-align: center;">
            <div style="font-size: 14px;">
              更新进度
            </div>
            <div>
              <span style="font-size: 24px;">{{schedule}}</span>
              <span style="font-size: 16px;">/{{Allcount}}</span>
            </div>
          </div>
          <div class="point">
            .
          </div>
          <div class="bDiv">
            <div style="font-size: 14px;">
              成功
            </div>
            <div class="fontDiv">
              {{succeed}}
            </div>
          </div>

          <div class="point">
            .
          </div>
          <div class="bDiv">
            <div style="font-size: 14px;">
              下架
            </div>
            <div class="fontDiv">
              {{shelves}}
            </div>
          </div>
          <div class="point">
            .
          </div>
          <div class="bDiv">
            <div style="font-size: 14px;">
              链接失效
            </div>
            <div class="fontDiv">
              {{loseEfficacy}}
            </div>
          </div>
          <div class="point">
            .
          </div>
          <div class="bDiv">
            <div style="font-size: 14px;">
              失败
            </div>
            <div class="fontDiv">
              {{failure}}
            </div>
          </div>
          <div style="float: left;width: 20%;text-align: center;">
            <div style="font-size: 16px;">
              <div v-if="settingUpdateProgress == 0">
                <i class="el-icon-time" style="color: #faad14;"></i>
                排队中
                <el-popover placement="top" trigger="click" width="250">
                  <div style="display: flex;">
                    前方还有
                    <div style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;">
                      {{loadingcount}}
                    </div>
                    条链接待更新
                  </div>
                  <div style="display: flex;">
                    预计等待时间
                    <div style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;">
                       {{loadingtime}}
                    </div>
                  </div>
                  <div style="margin-left: 20px;color: #1989fa;" slot="reference" @click="getupdatesituation">
                    排队情况
                  </div>
                </el-popover>
              </div>
               <span v-if="settingUpdateProgress == 1 || changeTime" style="font-size: 24px;">
                 <i class="el-icon-time" style="color: #faad14;"></i>
                 正在进行中
               </span>
               <span v-if="settingUpdateProgress == 2" style="font-size: 24px;">
                 <i class="el-icon-error" style="color: #e90e24;"></i>
                 更新异常
               </span>
               <span v-if="settingUpdateProgress == 3 || changeTime">
                 <i class="el-icon-success" style="color: green;font-size: 24px;"></i>
                 已完成
                 <el-tooltip class="item" effect="dark" placement="top">
                   <div slot="content">
                     为什么更新进度数量显示未更新完成，更新<br/>
                     状态却显示已完成？<br/>
                     答：①服务器更新进程任务过多，或代理质<br/>
                     量不好时，会导已在更新队列的链接跳过更<br/>
                     新。②更新进程受外部因素被停掉，重新启<br/>
                     动后，会导致部分链接状态已改变，但实际<br/>
                     并未更新。③单次更新条数少于400条，<br/>
                     加入队列后会提前显示已完成。<br/>
                     建议：出现上述情况后，请根据商品库中链<br/>
                     接的数据更新时间，查找遗漏链接，并手动<br/>
                     更新。
                   </div>
                   <i class="el-icon-warning-outline" style="font-size: 14px;"></i>
                 </el-tooltip>
                 <div style="font-size: 14px;text-align: center;margin-top: 16px;" v-if="settingdetail">
                   <span style="color: red;">
                     ●
                   </span>
                   本次未查询到待更新链接
                 </div>
               </span>
               <span v-if="settingUpdateProgress == 4" style="font-size: 24px;">
                 <i class="el-icon-warning" style="color: #bda571;"></i>
                 等待中
               </span>
               <span v-if="settingUpdateProgress == 5" style="font-size: 24px;">
                 <i class="el-icon-error" style="color: red;"></i>
                 已取消
               </span>
            </div>
          </div>
        </div>
      </el-row>


    </section>
    <div class="page" v-if="settingUpdateProgress == 2 || settingUpdateProgress == 3">
        <el-row style="margin-bottom: 5px;">
          <!-- <el-col :span="14" class="redFont" v-if="settingUpdateProgress == 2">
            更新异常、失败连接信息、请手动更新
          </el-col> -->
          <el-col :span="14" class="redFont" v-if="tableData.length != [] && tableData.length > 0">
            以下是更新失败、异常链接信息，请手动更新
          </el-col>
          <el-col :span="10" v-if="settingUpdateProgress == 2">
            <el-button plain style="margin-right: 10px;float: right;" @click="batchOutage" size="small">下载数据</el-button>
          </el-col>
          <el-col :span="10" v-if="settingUpdateProgress != 2 && failure != 0">
            <el-button plain style="margin-right: 10px;float: right;" @click="batchOutage" size="small">下载数据</el-button>
          </el-col>
        </el-row>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="商品信息">
          <template slot-scope="scope" class="shopInfo">
            <div class="shopMain" style="display: flex;">
              <img style="height: 50px;width: 50px;" :src="scope.row.logopicurl" alt/>
              <div class="content" style="margin-left: 20px;">
                <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                  {{scope.row.itemtitle}}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="产品信息" prop="productname">
        </el-table-column>
        <el-table-column label="店铺信息">
          <template slot-scope="scope">
            <div>
              {{scope.row.shopname}}
              <img style="width: 15px;height: 15px;" :src='require("@/assets/img/platform/pla_"+scope.row.platform+".png")' alt class="edit_icon"/>
            </div>
            <div>
              {{scope.row.wangwang}}
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div v-if="tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>

    </div>
    <el-dialog :visible.sync="updateShow" width="360px" title="提示" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;padding: 20px 10px;text-align: center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;vertical-align: middle;"></i>
        <div style="line-height: 35px;">
          <div style="font-size: 16px;font-weight: 400;">你确认要取消本次更新吗？</div>
       </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureUpdate(0)" size="small" :loading="ficationLoading">确 定</el-button>
        <el-button @click="updateShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div style="font-size: 16px;">
            你确认要删除固定周期更新计划吗？
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureUpdate(1)" size="mini" :loading="ficationLoading">确 定</el-button>
        <el-button @click="deleteShow = false" size="mini" type="TheCustom" style="margin-left: 16px;">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import aes from "../../../libs/aes";
  import pagination from "../../../components/dataTable/pagination";
  export default {
    data() {
      return {
        shopnameArr: [],
        week: '',
        timeweek: '',
        deleteId: '',
        deleteShow: false,
        ficationLoading: false,
        settingdetail: '',
        newBegintime: '',
        newEndtime: '',
        updateId: '',
        updateShow: false,
        loadingcount: 0,
        loadingtime: '0 分钟',
        loading: false,
        totalNum: 100,
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        tableData:[],
        clear: '',
        schedule: 0,
        Allcount: 0,
        platform: '',
        succeed: 0,
        failure: 0,
        shelves: 0,
        loseEfficacy: 0,
        settingUpdateProgress: '10',
        createtime: '',
        starttime: '',
        updatetime: '',
        regulartime: '',
        settingtype: '',
        productname: '',
        productnameArr: [],
        minute: 0,
        changeTime: false,
        settingfixed: {},
      }
    },
    created(){
  	},
    mounted() {
      this.getdetails();
      this.clear = setInterval(() => {
        this.getdetails();
      }, 5000)
    },
    methods: {
      cancelUpdate() {
        this.updateShow = true
      },
      // 确认更新
      sureUpdate(e) {
        this.ficationLoading = true
        let datas = {};
        if (e == 1) {
          datas.type = Number(1)
          datas.id = this.deleteId
        } else {
          datas.type = Number(0)
          datas.id = this.updateId
        }
        let that = this;
        fetch({
          url: "hcm/iprNewPluginList/updateIprNewPluginListSetting",
          method: "post",
          data: datas,
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            that.ficationLoading = false;
            this.settingfixed = {}
            that.getdetails();
            that.updateShow = false;
            that.deleteShow = false;
            that.$message({ type: "success", message: "取消成功" });
          } else {
            that.$message({
              message: res.message,
              type: "error"
            });
          }
        });
      },
      getupdatesituation() {
        let params={
          platform: this.$route.query.platform,
          settingtype: 0,
        }
        fetch({
          url: "hcm/iprNewPluginList/getupdatesituation",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.loadingcount = data.loadingcount
            if (data.loadingtime < 60) {
              this.loadingtime = data.loadingtime + ' 秒钟'
            } else {
              let z
              z = data.loadingtime / 60
              this.loadingtime = Math.ceil(z) + ' 分钟'
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      // 更新进程重复调用
      getdetails() {
        let params={
          platform: this.$route.query.platform,
        }
        fetch({
          url: "hcm/iprNewPluginList/getdetails",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (data.settingfixed) {
              this.settingfixed = data.settingfixed
              this.deleteId = data.settingfixed.id
            }
            if (data.getdetails && data.getdetails.id) {
              this.updateId = data.getdetails.id
            }
            if (data.schedule) {
              this.schedule = data.schedule
            }
            if (data.Allcount) {
              this.Allcount = data.Allcount
            }
            if (data.succeed) {
              this.succeed = data.succeed
            }
            if (data.failure) {
              this.failure = data.failure
            }
            if (data.shelves) {
              this.shelves = data.shelves
            }
            if (data.loseEfficacy) {
              this.loseEfficacy = data.loseEfficacy
            }
            if (data.getdetails) {
              this.settingdetail = data.getdetails.settingdetail
              if (data.getdetails.platform) {
                this.platform = data.getdetails.platform
              }
              this.settingUpdateProgress = data.getdetails.settingUpdateProgress
              if (data.getdetails.starttime) {
                this.starttime = data.getdetails.starttime
              }
              if (data.getdetails.createtime) {
                this.createtime = data.getdetails.createtime
              }
              if (data.getdetails.updatetime) {
                let time = data.time * 1000
                this.updatetime = time+data.getdetails.updatetime
              }
              if (data.getdetails.regulartime) {
                this.regulartime = data.getdetails.regulartime
              }
              if (data.getdetails.week) {
                this.week = data.getdetails.week
              }
              if (data.getdetails.timeweek) {
                this.timeweek = data.getdetails.timeweek
              }
              if (data.getdetails.settingtype) {
                this.settingtype = data.getdetails.settingtype
              }
              // if (data.getdetails.productname != '全部商品') {
                if (data.getdetails.productname) {
                  this.productnameArr = data.getdetails.productname.split(',')
                }
                if (data.getdetails.shopnames) {
                  // console.log()
                  this.shopnameArr = data.getdetails.shopnames.split(',')
                }

                if (data.getdetails.settingtype == 3) {
                  this.newBegintime = data.getdetails.begintime
                  this.newEndtime = data.getdetails.endtime
                }
              // }
            } else {
              clearInterval(this.clear)
            }

            if (this.settingUpdateProgress == 2 || this.settingUpdateProgress == 3 || this.settingUpdateProgress == 5) {
              clearInterval(this.clear)
              this.getfailureList()
            }
            var nTime = this.updatetime - this.starttime;
            this.minute = nTime/1000/60;
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
            clearInterval(this.clear)
          }
        }).catch(err => {
          console.log(err)
          this.$message.error('接口异常');
          clearInterval(this.clear)
        });
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.getfailureList()
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.getfailureList()
      },
      getfailureList() {
        this.loading = true
        let params={
          platform: this.$route.query.platform,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        fetch({
          url: "hcm/iprNewPluginList/getfailureList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.content
            this.totalNum = data.totalElements
            this.loading = false
          } else {
            this.loading = false

            this.$message({
              message: res.message,
              type: "error"
            });
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      // 下载
      batchOutage() {
        let params={
          platform: this.$route.query.platform,
        }
        fetch({
          url: "hcm/iprNewPluginList/exportExcelfailureList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob"
        })
        .then((res)=>{
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '更新异常链接.xlsx')
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },

    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
  }
  .point {
    float: left;
    height: 40px;
    width: 1px;
    background: #e9e9e9;
    color: #e9e9e9;
  }
  .bDiv {
    float: left;
    width: 14%;
    text-align: center;
  }
  .fontDiv {
    font-size: 24px;
  }
  .redFont {
    color: red;
    font-size: 18px;
    font-weight: 600;
  }
  .spanPointer {
    color: #108cee;
    cursor: pointer;
  }

</style>
<style lang="scss">
#updateProcess {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
}
</style>
